import React, { useRef, useState } from 'react'

interface IframeProps {
  title?: string
  width?: string
  height?: string
  src?: string
}
const FACTORIAL_OPEN_POSITIONS_URL = '/api/open-jobs'
const ATTRIBUTES_TO_REMOVE = ['data-action', 'data-controller', 'role', 'data-job-postings-url']

const FactorialOpenPositions = ({
  title = 'Factorial Open Positions',
  width = '100%',
  height = '600px',
  src = FACTORIAL_OPEN_POSITIONS_URL,
}: IframeProps) => {
  const ref = useRef<HTMLIFrameElement>(null)
  const [iframeHeight, setIframeHeight] = useState(height)

  const handleOnload = () => {
    if (!ref?.current?.contentWindow?.document) return

    const innerDocument = ref.current.contentWindow.document

    const jobList = innerDocument.querySelectorAll('li')
    jobList?.forEach((job: HTMLLIElement) => {
      // We remove these attributes to avoid navigation inside the iframe
      ATTRIBUTES_TO_REMOVE.forEach(attribute => job.removeAttribute(attribute))
      // and add target="_parent" to the links to open them in the parent window
      job.querySelector('a')?.setAttribute('target', '_parent')
    })

    innerDocument.body?.setAttribute('style', 'overflow: hidden;')

    // Calculate the height of the iframe based on the height of the content
    const innerHeight = innerDocument.body?.scrollHeight
    setIframeHeight(`${innerHeight}px`)
  }

  return (
    <iframe
      ref={ref}
      title={title}
      width={width}
      height={iframeHeight}
      src={src}
      onLoad={handleOnload}
    />
  )
}

export default FactorialOpenPositions
